import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styles from './URLMgr.css';
import withStyles from '../../decorators/withStyles';
import { browserHistory } from 'react-router';
import { STATE } from '../../reducers';
import { locationToState } from '../../utils/utils';

// The set of global state parameters we track in the URL.
const URL_STATE = {
  place: true,
  waterLevel: true,
  stationNum: true,
  forecastName: true,
  forecastType: true,
  protection: true,
  impact: true,
  impactPct: true,
  impactGroup: true,
  comparisonType: true,
  eaeVariable: true,
  eaeIsPct: true,
  eaeDerivative: true,
  eaePercentile: true,
  eaeScenario: true,
  zillowIsPct: true,
  zillowModel: true,
  zillowPathway: true,
  zillowPlaceType: true,
  zillowProb: true,
  zillowVarType: true,
  zillowYear: true,
  zillowYrBuilt: true,
};

function objectsDiffer(obj1, obj2) {
  var differ = false;
  for (var k in obj1) {
    if (typeof obj1[k] === "object") {
      if (!(typeof obj2[k] === "object")) { return false; }
      differ = objectsDiffer(obj1[k], obj2[k]);
    } else {
      differ = obj1[k] !== obj2[k];
    }
    if (differ) {
      return true;
    }
  }
  return false;
}


class URLMgr extends Component {

  static propTypes = {
    error: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  stateToLocation(state) {
    var query = {};
    var pathname = '/' + state.place.type + '/' + state.place.id;

    // Always explicitly set parameters with location-based presets.
    // We use presence in the URL to determine whether or not to apply
    // the preset. We always want to use what's in the URL if it's there,
    // and only apply the preset if it's not there.
    query.level = state.waterLevel.level;
    query.unit = state.waterLevel.unit;
    query.forecastType = state.forecastType;

    // Update other parameters if they are different from the default

    const params = JSON.parse(JSON.stringify(URL_STATE));
    const excludedParams = [
      'place',
      'waterLevel',
      'forecastType',
    ];

    for (let excludedParam of excludedParams) {
      delete params[excludedParam];
    }

    for (let param of Object.keys(params)) {
      if (state[param] && state[param] !== STATE[param]) {
        query[param] = state[param];
      }
    }

    return {
      pathname: pathname,
      query: query,
      hash: '',
    }
  }

  replaceURL(props) {
    var loc = this.stateToLocation(props);
    browserHistory.replace({
      query: Object.assign({}, loc.query),
      pathname: loc.pathname,
      hash: loc.hash,
      state: props,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (objectsDiffer(this.props, nextProps)) {
      this.replaceURL(nextProps);
    }
  }

  render() {
    return (
      <div className="dummy"></div>
    )
  }

}

/*
 * Since we will trigger an action affecting the routing after updating, make sure
 * "routing" is not a property of the component to avoid an infinite loop.
 */
export default compose(
  withStyles(styles),
  connect((state) => {
    const props = {};
    for (var k in state) {
      if (k in URL_STATE) {
        props[k] = state[k];
      }
    }
    return props;
  }),
)(URLMgr);
